import { render } from "./HomePagePromotions.vue?vue&type=template&id=3afeb475&scoped=true"
import script from "./HomePagePromotions.vue?vue&type=script&lang=js"
export * from "./HomePagePromotions.vue?vue&type=script&lang=js"

import "./HomePagePromotions.vue?vue&type=style&index=0&id=3afeb475&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afeb475"]])

export default __exports__